import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface AgentSetSubscriptionResponse {
  message: string;
  agent_id: string;
  subscription_time: number;
  subscription_frequency: number;
  type: number;
  updated_at: string;
};

// 请求接口
interface AgentSetSubscriptionRequest {
  type: number,
  agentId: string;
  subscriptionTime: number;
  subscriptionFrequency: number;
}

export class AgentSetSubscriptionData {
  @Required("Subscription Time cannot be empty")
  @IsNumber("Subscription Time must be a number")
  subscriptionTime: number;

  @Required("Subscription Frequency cannot be empty")
  @IsNumber("Subscription Frequency must be a number")
  subscriptionFrequency: number;
}

const transformAndValidateAgent = (
  response: AgentSetSubscriptionResponse
): AgentSetSubscriptionData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, AgentSetSubscriptionData);
  } catch (error) {
    console.error("Agent Set Subscription data validation failed:", error.message);
    throw error;
  }
};

/** 更新 Agent 订阅 */
export const agentSetSubscription = async ({ agentId, subscriptionTime, subscriptionFrequency, type }: AgentSetSubscriptionRequest): Promise<AgentSetSubscriptionData> => {
  const response = await api.post<AgentSetSubscriptionResponse>('/agent/set-subscription', {
    type,
    agent_id: agentId,
    subscription_time: subscriptionTime,
    subscription_frequency: subscriptionFrequency,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
